import React from 'react';
interface LogoProps {
  size?: number;
  showText?: boolean;
  className?: string;
  monochrome?: boolean;
}
/**
 * Brand logo for "Sestri za tačke" — a soft rounded badge with two friendly paw prints
 * (one for each sister) curling around a little heart. Designed to read clearly even
 * at favicon size (16×16).
 */
export function Logo({
  size = 40,
  showText = false,
  className = '',
  monochrome = false
}: LogoProps) {
  const brown = monochrome ? '#4A3B32' : '#C9A789';
  const pink = monochrome ? '#4A3B32' : '#F8C8C8';
  const green = monochrome ? '#FFFBF5' : '#B8DDB8';
  const cream = '#FFFBF5';
  const text = '#4A3B32';
  return <div className={`inline-flex items-center gap-2 ${className}`} data-id="element-75">
      <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Sestri za tačke logo" role="img" data-id="element-76">
        {/* Soft rounded badge background */}
        <rect x="2" y="2" width="60" height="60" rx="18" fill={brown} data-id="element-77" />
        <rect x="2" y="2" width="60" height="60" rx="18" fill={cream} fillOpacity="0.08" data-id="element-78" />

        {/* Two paws nuzzling a heart — one paw per sister */}
        {/* Heart in center */}
        <path d="M32 41c-7-4.2-11-8.4-11-13.2 0-3 2.4-5.4 5.4-5.4 2.1 0 3.9 1.2 4.8 3 .9-1.8 2.7-3 4.8-3 3 0 5.4 2.4 5.4 5.4 0 4.8-4 9-9.4 13.2Z" fill={pink} data-id="element-79" />

        {/* Left paw (smaller, tucked) */}
        <g transform="translate(10 18) rotate(-15)" data-id="element-80">
          <circle cx="6" cy="6" r="3.4" fill={green} data-id="element-81" />
          <circle cx="11.5" cy="2.5" r="2.4" fill={green} data-id="element-82" />
          <circle cx="0.5" cy="2.5" r="2.4" fill={green} data-id="element-83" />
          <circle cx="3" cy="-2" r="2" fill={green} data-id="element-84" />
          <circle cx="9" cy="-2" r="2" fill={green} data-id="element-85" />
        </g>

        {/* Right paw (slightly larger, mirrored) */}
        <g transform="translate(48 44) rotate(15)" data-id="element-86">
          <circle cx="0" cy="0" r="3.8" fill={cream} data-id="element-87" />
          <circle cx="-6" cy="-3.5" r="2.6" fill={cream} data-id="element-88" />
          <circle cx="5.5" cy="-3.5" r="2.6" fill={cream} data-id="element-89" />
          <circle cx="-3" cy="-8" r="2.2" fill={cream} data-id="element-90" />
          <circle cx="3.5" cy="-8" r="2.2" fill={cream} data-id="element-91" />
        </g>
      </svg>

      {showText && <span className="font-display font-bold leading-none" style={{
      color: text,
      fontSize: size * 0.45
    }} data-id="element-92">
          Sestri za{' '}
          <span style={{
        color: brown
      }} data-id="element-93">
            tačke
          </span>
        </span>}
    </div>;
}